import { render, staticRenderFns } from "./ActivityList.vue?vue&type=template&id=f0631858&scoped=true"
import script from "./ActivityList.vue?vue&type=script&lang=js"
export * from "./ActivityList.vue?vue&type=script&lang=js"
import style0 from "./ActivityList.vue?vue&type=style&index=0&id=f0631858&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0631858",
  null
  
)

export default component.exports